import type { TrainingLessonSpecific } from './trainingLessonUi';

export const elder2LeadershipEs: TrainingLessonSpecific = {
  intro:
    'Liderazgo en el sacerdocio es influencia moral, no cargo. El Elder lidera sin dominar, apoya a los líderes, acompaña a los débiles y cuida a su familia. La constancia vence al carisma.',
  objectives: [
    'Liderar sin dominar.',
    'Apoyar a los líderes del barrio.',
    'Acompañar a los débiles.',
    'Cuidar a la familia espiritualmente.',
    'Crear un plan personal de liderazgo servicial.',
  ],
  briefHeading: 'Liderazgo servicial en breve',
  briefBody:
    'Persuadir con mansedumbre, servir primero, y ser leal a quienes presiden. El liderazgo del sacerdocio edifica, no controla.',
  scriptures: [
    { ref: 'DyC 121:34–46', text: 'Solo por persuasión, longanimidad, benignidad, amor sincero.' },
    { ref: 'Juan 13:14–15', text: 'Si yo, el Señor y el Maestro, os he lavado los pies, vosotros también debéis lavaros los pies unos a otros.' },
    { ref: 'DyC 107:99–100', text: 'Aprende tu deber y obra con diligencia en el oficio en que fuiste nombrado.' },
    { ref: 'Alma 17:11', text: 'Paciencia y buen ejemplo en aflicciones; el Señor os hará instrumentos para salvar almas.' },
    { ref: 'DyC 58:27', text: 'Anhelosamente consagrados a una causa buena, obrando por propia voluntad.' },
  ],
  didYouKnow: [
    'Liderazgo en el sacerdocio es influencia moral, no cargo.',
    'La constancia vence al carisma.',
  ],
  practiceItems: [
    'Hacer un acto de servicio oculto (sin que nadie lo sepa)',
    'Dar un consejo con humildad cuando me lo pidan',
    'Establecer un plan espiritual familiar (oración, lectura, noche de hogar)',
    'Coordinar con líderes para saber cómo apoyar',
    'Ofrecer mentoría 1 a 1 a alguien más joven o nuevo',
    'Revisión semanal: ¿qué hice bien y qué mejoraré?',
  ],
  reflectionQuestions: [
    '¿Cómo sirvo hoy? ¿Qué cambiaría?',
    '¿Dónde debo crecer como líder servicial?',
    '¿A quién puedo mentorear o acompañar?',
  ],
  actionText: 'Elegir a 1 persona para acompañar por 30 días.',
};
